// src/services/authService.js
import { authApi, authSecureApi } from '../utils/apiConfig';

export const authService = {
  checkEmail: async (email) => {
    const response = await authApi.get(`/api/auth/checkMail?email=${encodeURIComponent(email)}`);
    return response.data;
  },
  // NEW: Added phone number existence check API
  checkPhoneNumber: async (phoneNumber) => {
    const response = await authApi.get(`/api/auth/checkPhoneNumber?phoneNumber=${encodeURIComponent(phoneNumber)}`);
    return response.data;
  },
  sendOtp: async (email) => {
    const response = await authApi.post(`/api/auth/send-otp?email=${encodeURIComponent(email)}`);
    return response.data;
  },
  // NEW: Added SMS OTP sending API
  sendSmsOtp: async (phoneNumber) => {
    const response = await authApi.post(`/api/auth/send-sms-otp?phoneNumber=${encodeURIComponent(phoneNumber)}&purpose=REGISTER`);
    return response.data;
  },
  // FIXED: Changed payload to handle dynamic email/phoneNumber object
  verifyOtp: async (payload) => {
    const response = await authApi.post('/api/auth/otp-verify', payload);
    return response.data;
  },
  // FIXED: Changed payload to accept identifier
  login: async (credentials) => {
    const response = await authApi.post('/api/auth/login', credentials);
    return response.data;
  },
  register: async (userData) => {
    const response = await authApi.post(`/api/auth/register`, userData);
    return response.data;
  },
  // --- Secured APIs below (using authSecureApi) ---
  getProfile: async () => {
    const response = await authSecureApi.get('/api/auth/profile');
    return response.data;
  },
  updateDetails: async (data) => {
    const response = await authSecureApi.patch('/api/auth/updateDetails', data);
    return response.data;
  },
  deleteAccount: async (userId) => {
    const response = await authSecureApi.patch(`/api/auth/account/delete?userId=${userId}`);
    return response.data;
  },
  changePassword: async (data) => {
    const response = await authSecureApi.patch('/api/auth/change-password', data);
    return response.data;
  },
  // FIXED: Updated forgot password API to use the SMS endpoint
  forgotPasswordSms: async (phoneNumber) => {
    const response = await authApi.post(`/api/auth/forgot-password-sms?phoneNumber=${encodeURIComponent(phoneNumber)}`);
    return response.data;
  },
  // NEW: Reset password API 
  resetPasswordSms: async (payload) => {
    const response = await authApi.post('/api/auth/reset-password-sms', payload);
    return response.data;
  }
};